// servicesData.js

import ComputerIcon from "@mui/icons-material/Computer";
import PsychologyIcon from "@mui/icons-material/Psychology";

import {
  PrideFlagIcon,
  TransgenderFlagIcon,
  AutismInfinityIcon,
} from "../common/RainbowIcon";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ManIcon from "@mui/icons-material/Man";
import WomanIcon from "@mui/icons-material/Woman";
import rings from "../../assets/images/services/rings.png";
import sexTherapyIcon from "../../assets/images/services/sex-therapy-icon.png";
import lackOfDesireIcon from "../../assets/images/services/lack-of-desire.png";

export const categories = {
  Relationship: [
    {
      label: "Marriage Counseling",
      description:
        "For couples who keep having the same fights, feel more like roommates than partners, or just want to reconnect before things get worse.",
      Icon: rings,
      featured: true,
      priority: 2,
    },
    {
      label: "Sex Therapy for Couples",
      description:
        "A comfortable place for couples to talk about what is hard to bring up at home, from mismatched desire to feeling disconnected in bed.",
      Icon: sexTherapyIcon,
      featured: true,
      priority: 3,
    },
    {
      label: "Lack of Desire",
      description:
        "When one of you wants sex more than the other, or desire has faded altogether, therapy can help you understand why and find your way back to each other.",
      Icon: lackOfDesireIcon,
      featured: false,
      priority: null,
    },
  ],
  Individual: [
    {
      label: "Online Sexual Addiction",
      description:
        "If porn or other online sexual behavior feels out of control and is hurting your life or relationship, there is a path forward without shame.",
      Icon: ComputerIcon,
      featured: true,
      priority: 1,
    },
    {
      label: "Female Sexual Dysfunction",
      description:
        "For women dealing with pain during sex, trouble with arousal or orgasm, or changes after childbirth or menopause. These things are common and treatable.",
      Icon: WomanIcon,
      featured: false,
      priority: null,
    },
    {
      label: "Male Sexual Dysfunction",
      description:
        "For men dealing with erectile difficulties, finishing too quickly, or performance anxiety. These issues are more common than you think, and they respond well to therapy.",
      Icon: ManIcon,
      featured: false,
      priority: null,
    },

    {
      label: "Autism Support for Adults",
      description:
        "Support for autistic adults, whether you were diagnosed as a kid or just figured it out. No pressure to mask or act neurotypical here.",
      Icon: AutismInfinityIcon,
      featured: true,
      priority: 6,
    },
    {
      label: "Autism Support for Children",
      description:
        "Gentle, practical help for autistic kids and their parents, from social skills and big feelings to sensory overwhelm at school and home.",
      Icon: AllInclusiveIcon,
      featured: false,
      priority: null,
    },
    {
      label: "LGBTQ Counseling",
      description:
        "Affirming counseling for LGBTQ individuals and couples. Whether you are coming out, working through family stuff, or just want a therapist who gets it.",
      Icon: PrideFlagIcon,
      featured: true,
      priority: 4,
    },
    {
      label: "Transgender Counseling",
      description:
        "Support for trans and gender-questioning people at every stage, from early exploration through transition, following WPATH standards of care.",
      Icon: TransgenderFlagIcon,
      featured: true,
      priority: 5,
    },
    {
      label: "Senior Support",
      description:
        "Counseling for older adults working through loss, retirement, health changes, loneliness, or intimacy in later life. It is never too late to start.",
      Icon: FavoriteBorderIcon,
      featured: false,
      priority: null,
    },
    {
      label: "Straight Spouse Support",
      description:
        "When your husband or wife comes out, your whole world shifts too. This is a place to process the shock, grief, and questions that follow.",
      Icon: PsychologyIcon,
      featured: false,
      priority: null,
    },
  ],
};

export const services = Object.entries(categories).flatMap(
  ([category, services]) =>
    services.map((service) => ({
      ...service,
      category,
    }))
);

// Export filtered versions for different use cases
export const featuredServices = services
  .filter((service) => service.featured)
  .sort((a, b) => a.priority - b.priority);

export const allServices = services;
